if (!customElements.get('cart-drawer-info-slider')) {
  class CartDrawerInfoSlider extends HTMLElement {
    constructor() {
      super();

      if (Shopify.designMode) {
        // Keep a ref so disconnectedCallback can detach it; otherwise this
        // window listener accumulates on every section reload in the editor.
        this._onSectionLoad = () => {
          this.init();
        };
        window.addEventListener('shopify:section:load', this._onSectionLoad);
      }
      this.init();


    }

    disconnectedCallback() {
      if (this._onSectionLoad) window.removeEventListener('shopify:section:load', this._onSectionLoad);
      if (this.slider && typeof this.slider.destroy === 'function') {
        this.slider.destroy(true, true);
        this.slider = null;
      }
    }

    init() {

      var swiperArea = document.querySelector('.cart-drawer__swiper');

      // Destroy the previous instance before re-creating it to avoid leaks.
      if (this.slider && typeof this.slider.destroy === 'function') {
        this.slider.destroy(true, true);
        this.slider = null;
      }

      this.slider = new Swiper(swiperArea, {
        direction: 'vertical',
        slidesPerView: 1,
        loop: true,
        allowTouchMove: false,
        autoplay: {
          delay: 5000,
        }
      });
    }
  }

  customElements.define('cart-drawer-info-slider', CartDrawerInfoSlider);
}
